/**
 * Norlyn a11y (audit 5.3.8): announces quantity changes to screen readers.
 *
 * The plus and minus buttons of a quantity selector change the number in the
 * input, but screen readers do not announce a changed input value. This writes
 * "Määrä 2" into the page-level status region #a11y-status, which
 * layout/theme.liquid renders outside every morphed section, so the message
 * survives the cart re-render. The listener is delegated from document
 * (see CLAUDE.md, "Horizon Morph System Gotchas").
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('.quantity-plus, .quantity-minus') : null;
    // No disabled check: the theme's handler runs first and may already have disabled
    // the button it just used (minus at the minimum), and a click on a button that was
    // disabled beforehand never reaches this listener.
    if (!button) return;

    var status = document.getElementById('a11y-status');
    var input = button.parentElement ? button.parentElement.querySelector('input[type="number"]') : null;
    if (!status || !(input instanceof HTMLInputElement)) return;

    // The theme's own click handler (capture phase) has already updated the value.
    var message = (status.dataset.quantityLabel || 'Määrä') + ' ' + input.value;

    // Clear first so that the same message twice in a row is announced again.
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 100);
  });
})();
